// extracted by mini-css-extract-plugin
module.exports = {"main-yellow":"#fcd406","main-gray":"#b4b4b4","gray-dark":"#777","container":"ButtonRect-module__container___3FQZj"};